// Copyright 2020-2025 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: GPL-3.0

import { DictionaryV2QueryEntry } from '@subql/node-core';

/**
 * Substrate Fat dictionary RPC request filter conditions
 */
export type SubstrateDictionaryV2QueryEntry = DictionaryV2QueryEntry;
